(function () {
  angular.module("akitabox.ui.dialogs.inspectionProgram.create", [
    "akitabox.core.constants",
    "ngMaterial",
    "akitabox.core.services.timeZone",
    "akitabox.core.ui.dialogs.inspectionProgram.create.inspectionComponentSection",
    "akitabox.core.ui.dialogs.inspectionProgram.create.inspectionDetailSection",
  ]);
})();
